import { create } from "zustand";
import { User } from "firebase/auth";
import { cookieManager } from "@shared/src/lib/auth/cookieManager";
import { useHostStore } from "@shared/src/stores/useHostStore";
import { SdkClient } from "@sdk/index";

interface AdminUser {
  email: string;
  name: string;
  photoUrl: string;
}

interface AdminAuthStore {
  adminUser: AdminUser | null;
  isLoading: boolean;
  setAdminUser: (user: User | AdminUser | null) => void;
  clearAdminUser: () => void;
  initializeAuth: (sdk: SdkClient) => void;
}

const STORAGE_KEY = "admin_user_data";

export const useAdminAuthStore = create<AdminAuthStore>((set, get) => ({
  adminUser: null,
  isLoading: true,
  setAdminUser: user => {
    if (!user) {
      set({ adminUser: null });
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    // If it's a Firebase User
    if ("email" in user && ("displayName" in user || "photoURL" in user)) {
      const adminUser = {
        email: user.email || "",
        name: (user as any).displayName || "",
        photoUrl: (user as any).photoURL || "",
      };
      set({ adminUser });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(adminUser));
    } else {
      // If it's a plain AdminUser
      set({ adminUser: user as AdminUser });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    }
  },
  clearAdminUser: () => {
    set({ adminUser: null });
    localStorage.removeItem(STORAGE_KEY);
  },
  initializeAuth: (sdk: SdkClient) => {
    // Try to load from localStorage first
    try {
      console.log("qwerty one", {
        isLoading: get().isLoading,
        adminUser: sdk.auth.adminToken,
      });
      // Set SDK admin token if cookie present
      const token = cookieManager().getAdminAuthToken();
      console.log("admintoken", token);
      if (token) {
        if (sdk) {
          try {
            sdk.auth.setAdminToken(token);
          } catch (e) {
            console.warn("Failed to set admin token in SDK", e);
          }
        }
        const storedData = localStorage.getItem(STORAGE_KEY);
        if (storedData) {
          const adminUser = JSON.parse(storedData);
          set({ adminUser });
        }
      }
    } catch (error) {
      console.error("Error loading admin user from localStorage:", error);
    } finally {
      set({ isLoading: false });
      console.log("qwerty two", {
        isLoading: get().isLoading,
        adminUserrtien: sdk?.auth.adminToken,
      });
    }
  },
}));
